import React from 'react';
import { useExportTranscriptsVDescriptorMutation } from './mutations';
import { useProject } from '../projects/queries';
import { useAllProjectTranscripts } from '../transcripts/queries';
import { useDescriptors } from '../descriptors/queries';

/**
 * Hook for the transcript x descriptor export (used on the reports page)
 * Downloads a CSV with one row per transcript and one column per descriptor,
 * where each cell is the descriptor option selected for that transcript
 */
export function useTranscriptsVDescriptorExport(projectId) {
  const { data: projectData, isLoading: projectLoading } = useProject(projectId);
  // Gate on isFetching (not just isLoading): useAllProjectTranscripts returns
  // the first 500 transcripts immediately and keeps fetching the rest in the
  // background — exporting mid-fetch would silently drop rows.
  const { data: transcripts, isFetching: transcriptsFetching } = useAllProjectTranscripts(projectId);
  const { data: descriptorsData, isLoading: descriptorsLoading } = useDescriptors(projectId);
  const mutation = useExportTranscriptsVDescriptorMutation(projectData, transcripts, descriptorsData);

  return {
    exportTranscriptsVDescriptor: () => mutation.mutate(),
    isExporting: mutation.isPending,
    error: mutation.error,
    // Data presence checks keep the button disabled when a query errored out
    // (isLoading settles false with data undefined), which would otherwise
    // export a plausible-looking but empty CSV
    isReady: !!projectId && !projectLoading && !!projectData &&
      !transcriptsFetching && !!transcripts &&
      !descriptorsLoading && !!descriptorsData
  };
}
